// External library imports
import styled from 'styled-components';

// External type imports
import type { BoxProps } from '@interstate/components/Box';

export const styles: Record<string, BoxProps['sx']> = {
    container: {
        marginTop: 6,
        '&:first-child': {
            marginTop: 0
        }
    },
    heading: {
        marginTop: 2,
        marginBottom: 4
    }
};

export const Separator = styled.span<{ isVisible: boolean }>`
    background-color: ${({ theme }) => theme.tokens.BaseColorGray300};
    visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
    margin: ${({ theme }) => theme.tokens.BaseSpace25} 0;
    display: flex;
    margin-bottom: ${({ isVisible }) => (isVisible ? '1rem' : '0.5rem')};
    margin-top: ${({ isVisible }) => (isVisible ? '1.5rem' : '0.5rem')};
    width: 100%;
    height: 0.5px;
    border-radius: 2px;
`;
